function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { cva } from "class-variance-authority";
import { cn } from "../../common/helpers.js";
const classes = cva([
    'block',
    'rounded-xl'
], {
    variants: {
        variant: {
            elevated: [
                'bg-gray-50',
                'shadow',
                'transition-shadow',
                'duration-200'
            ],
            filled: [
                'bg-gray-50',
                'border-2',
                'border-primary-50'
            ],
            outlined: [
                'bg-white',
                'border-2',
                'border-gray-100'
            ]
        },
        padding: {
            none: [],
            sm: [
                'p-4'
            ],
            md: [
                'p-6'
            ],
            lg: [
                'p-8'
            ]
        },
        noAction: {
            true: [],
            false: []
        }
    },
    compoundVariants: [
        {
            variant: 'elevated',
            noAction: false,
            className: [
                'cursor-pointer',
                'hover:shadow-md',
                'outline-2',
                'outline-offset-2',
                'outline-primary'
            ]
        }
    ]
});
/**
 * Card - [API](https://scl.sharp.com/?path=/docs/base-card)
 */ const Card = /*#__PURE__*/ forwardRef((_param, ref)=>{
    var { as, className, variant = 'elevated', padding = 'md', noAction = false } = _param, props = _object_without_properties(_param, [
        "as",
        "className",
        "variant",
        "padding",
        "noAction"
    ]);
    const Root = as !== null && as !== void 0 ? as : !noAction && variant === 'elevated' ? 'a' : 'article';
    return /*#__PURE__*/ _jsx(Root, _object_spread_props(_object_spread({}, props), {
        ref: ref,
        className: cn(classes({
            variant,
            padding,
            noAction,
            className
        }))
    }));
});
export { Card };
